import React, { ReactNode } from "react";

import {
  BackgroundImage,
  Box,
  Button,
  Group,
  Image,
  Stack,
  Text
} from "@mantine/core";

import HStack from "modules/core/components/HStack";

import Logo from "modules/core/assets/img/efestra-logo.png";
import BgImg from "modules/core/assets/img/login-bg-efestra.png";
// import Logo from "modules/core/assets/img/efestra-logo.png";
import CampaignContent from "../CampaignContent";

import classes from "./styles.module.css";

interface IProps {
  title?: string;
  img?: ReactNode;
  children: React.ReactNode;
}

const AuthLayout: React.FC<IProps> = props => {
  const { title, img, children } = props;

  return (
    <Group gap={0}>
      <CampaignContent />
      {/* <Box w="50%" h="100vh">
        <BackgroundImage src={BgImg} w="100%" h="100%">
          <Stack px="15%" py={180} c="white" justify="flex-start">
            <Text fz="xl" fw="bold">
              Welcome To
            </Text>

            <Image src={Logo} w={200} mb={50} fit="contain" />

            <Button
              color="yellow"
              c="dark"
              size="xl"
              bg="white"
              radius="lg"
              component="a"
              href="https://intercom.help/efestra/en/articles/11672193-from-effective-experiments-to-efestra-where-experiments-become-strategy"
              target="_blank"
              rel="noopener noreferrer"
              w={400}
              className={classes.button}
            >
              Learn More About Our New Brand
            </Button>
          </Stack>
        </BackgroundImage>
      </Box> */}

      <Stack w="50%" h="100vh" justify="center" align="center" bg="white">
        {img ? <Box mb="lg">{img}</Box> : null}

        {title ? (
          <Text fz="h4" fw={700} mb="lg">
            {title}
          </Text>
        ) : null}

        <Box w="100%" maw={450} mx="auto">
          {children}
        </Box>
      </Stack>
    </Group>
  );
};

export default React.memo(AuthLayout);
